import { Component, HostBinding, Input } from '@angular/core';
import { CloseSectionType } from 'extensions/core/slice-flex/front/slice-flex-settings.model';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { AmandaOptions, AssetsSharedService } from 'shared/services/assets-shared.service';


import { SliceDragSettings } from 'extensions/st/slice-drag/front/settings/slice-drag-settings.model';

import { templateUrl, styleUrls } from './slice-drag-close.component.paths';


@Component({
  selector: 'slice-drag-close',
  templateUrl,
  styleUrls
})
export class SliceDragCloseComponent {

  @Input() public settings!: SliceDragSettings;
  @Input() public isMobile: boolean = false;

  @HostBinding('style.--custom-width')
  public get closeSectionCustomWidth(): string | undefined {
    if (!this.settings.general.closeSectionCustomSize?.isCloseSectionCustomSizeEnabled) {
      return undefined;
    }

    return this.settings.general.closeSectionCustomSize.width ?? undefined;
  }

  @HostBinding('style.--custom-height')
  public get closeSectionCustomHeight(): string | undefined {
    if (!this.settings.general.closeSectionCustomSize?.isCloseSectionCustomSizeEnabled) {
      return undefined;
    }

    return this.settings.general.closeSectionCustomSize.height ?? undefined;
  }

  @HostBinding('class.left')
  public get display(): boolean {
    return this.settings.general.closeSectionPosition === 'left';
  }

  @HostBinding('class.mobile')
  public get mobile(): boolean {
    return this.isMobile;
  }

  constructor(
    protected readonly renderConfigurationService: RenderConfigurationService,
    private readonly assetsSharedService: AssetsSharedService
  ) {}

  public get closeSectionType(): CloseSectionType {
    return this.settings.general.closeSectionType ?? 'icon';
  }

  public get closeSectionText(): string {
    return this.settings.general.closeSectionText ?? '';
  }

  public get closeSectionCustomImage(): string | undefined {
    const assetsUrl = this.renderConfigurationService.config.assetsUrl;
    const akamaiOptions: AmandaOptions = { isWidthParamEnabled: false };
    const image = this.settings.general.closeSectionCustomImage?.image ?? undefined;

    return this.assetsSharedService.getAssetUrl(image, assetsUrl, akamaiOptions);
  }

}
